export type VehicleRouteInfo = {
    start: [number, number],
    end: [number, number],
    wayPoints: [number, number][],
    type?: google.maps.TravelMode,
};

export const HALLEY_RISE_ROUTE: VehicleRouteInfo = {
    start: [38.95031070022613, -77.36119177692837],
    end: [38.95018975209714, -77.36093004501012],
    wayPoints: [
        [38.94981510657828, -77.36150661386043],
        [38.948720658340875, -77.3589917115156],
        [38.94795364947829, -77.35977690721865],
        [38.94722498339701, -77.35921930443631],
        [38.948664607949496, -77.361529373106],
        [38.949626308061674, -77.36105142786398],
        [38.94973250727408, -77.36127143440396],
    ],
};

export const BROOKLYN_NAVY_YARD_ROUTE: VehicleRouteInfo = {
    start: [40.70126923596794, -73.97282132579888],
    end: [40.70126923596794, -73.97282132579888],
    wayPoints: [
        [40.69953194573375, -73.97071472621066],
        [40.69953536564087, -73.9697133019979],
        [40.69913181538721, -73.9697313456774],
        [40.69918653420894, -73.97064255149262],
        [40.69953194573375, -73.97071472621066],
        [40.6996448025787, -73.97265893268336],
        [40.69841020671355, -73.97462569375817],
        [40.699232518619496, -73.97557632242957],
        [40.70039717663407, -73.97364231322491],
        [40.69955930497975, -73.97093576129026],
    ],
};

// so google maps doesnt consider the docks as drivable , thus I had to change
// to walking to get it to highlight
export const BROOKLYN_NAVY_YARD_DOCKS_ROUTE: VehicleRouteInfo = {
    start: [40.701417, -73.973056],
    end: [40.701417, -73.973056],
    wayPoints: [
        [40.69956601147972, -73.97096292318352],
    ],
    // since this is a constant and google maps is not loaded yet on init,
    // we just hard code the constant
    type: "WALKING" as google.maps.TravelMode.WALKING,
};

export const CLOSED_LOOP_ROUTES: { [keys: number]: VehicleRouteInfo[] } = {
    3: [BROOKLYN_NAVY_YARD_DOCKS_ROUTE, BROOKLYN_NAVY_YARD_ROUTE],
    4: [HALLEY_RISE_ROUTE],
};
